import { render, staticRenderFns } from "./PrivateTv.vue?vue&type=template&id=bcc03bb6&scoped=true&"
import script from "./PrivateTv.vue?vue&type=script&lang=js&"
export * from "./PrivateTv.vue?vue&type=script&lang=js&"
import style0 from "./PrivateTv.vue?vue&type=style&index=0&id=bcc03bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc03bb6",
  null
  
)

export default component.exports